export const PRE_AUTH_TAG = 'GTM-TJGLRD9';
export const POST_AUTH_TAG = 'GTM-N745T8T';
